import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import { IconGlobe, IconMail, IconMonitor } from "../../components/Icons";

const ACCENT = "#1A6CF6";

const FAQS = [
  {
    question: "Posso migrar meu site e e-mail atual para o sepolHOSTING?",
    answer:
      "Sim. A sepolTECH realiza a migração completa do seu site e contas de e-mail para o sepolHOSTING, sem downtime. Nossa equipe cuida de todo o processo técnico.",
  },
  {
    question: "O e-mail funciona em celular e Outlook?",
    answer:
      "Sim. O e-mail do sepolHOSTING é compatível com qualquer cliente de e-mail (Outlook, Gmail, Apple Mail, Thunderbird) e celulares Android e iPhone, via IMAP e POP3.",
  },
  {
    question: "O que é VPS e quando preciso de um?",
    answer:
      "VPS (Virtual Private Server) é um servidor virtual com recursos dedicados exclusivos para você. É indicado quando sua aplicação precisa de mais performance, controle de configurações ou recursos garantidos — diferente da hospedagem compartilhada.",
  },
  {
    question: "O plano inclui backup?",
    answer:
      "O sepolHOSTING inclui backup básico. Para uma solução de backup gerenciada e completa, recomendamos também o sepolBACKUP, que garante cópias automáticas, monitoradas e validadas pela sepolTECH.",
  },
];

const FEATURES = [
  {
    title: "E-mail Corporativo",
    desc: "Caixas de e-mail profissional com seu domínio (@suaempresa.com.br)",
  },
  {
    title: "Hospedagem de Sites",
    desc: "Hospedagem estável para sites em WordPress, PHP e HTML",
  },
  {
    title: "VPS",
    desc: "Servidores virtuais privados para aplicações e sistemas que exigem mais controle",
  },
  {
    title: "SSL Incluído",
    desc: "Certificado de segurança HTTPS para todos os domínios",
  },
  {
    title: "Suporte sepolTECH",
    desc: "Gestão e suporte técnico incluídos, sem custo adicional",
  },
  {
    title: "Painel de Controle",
    desc: "cPanel intuitivo para gerenciar e-mails, arquivos e domínios",
  },
];

const HIGHLIGHT_CARDS = [
  {
    Icon: IconMail,
    title: "E-mail Corporativo",
    desc: "Caixas profissionais com seu domínio, webmail, IMAP/POP3 e antispam incluso.",
    featured: false,
  },
  {
    Icon: IconGlobe,
    title: "Sites & Aplicações",
    desc: "WordPress, PHP, HTML. Suporte a múltiplos domínios e subdomínios.",
    featured: false,
  },
  {
    Icon: IconMonitor,
    title: "VPS Dedicado",
    desc: "Recursos dedicados, root access e escalabilidade quando seu negócio crescer.",
    featured: true,
  },
];

export default function SepolHosting() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <Link to="/produtos/produtos">Produtos</Link>
            <span>/</span>
            <span>sepolHOSTING</span>
          </div>
          <div className="tag animate-up animate-up--d1" style={{ color: ACCENT, background: "rgba(26,108,246,.1)", borderColor: "rgba(26,108,246,.25)" }}>
            <IconGlobe style={{ width: "13px", height: "13px" }} />
            Cloud Hosting · SaaS / IaaS
          </div>
          <h1
            className="animate-up animate-up--d2"
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(40px,6vw,72px)",
              fontWeight: 700,
              letterSpacing: "-.03em",
              lineHeight: "1.05",
              marginBottom: "24px",
              color: "var(--text-primary)",
            }}
          >
            sepol<span style={{ color: ACCENT }}>HOSTING</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "540px",
              lineHeight: "1.7",
              marginBottom: "40px",
            }}
          >
            Hospedagem web profissional em nuvem. E-mail corporativo, sites e
            VPS — infraestrutura estável com toda a gestão e suporte da
            sepolTECH incluídos.
          </p>
          <div className="hero-actions-col animate-up animate-up--d4">
            <Link to="/contato" className="btn btn-primary">
              Contratar sepolHOSTING →
            </Link>
            <Link to="/contato" className="btn btn-outline">
              Falar com especialista
            </Link>
          </div>
        </div>
      </section>

      {/* ═══════════════ O QUE ESTÁ INCLUSO ═══════════════ */}
      <section className="section">
        <div className="container">
          <div className="grid-2col">
            <Reveal>
              <div className="tag" style={{ color: ACCENT, background: "rgba(26,108,246,.1)", borderColor: "rgba(26,108,246,.25)" }}>
                O que está incluso
              </div>
              <h2 className="section-title">
                Tudo que sua empresa
                <br />
                <span style={{ color: ACCENT }}>precisa na web</span>
              </h2>
              <div className="feature-list" style={{ marginTop: "24px" }}>
                {FEATURES.map((feature) => (
                  <div className="feature-item" key={feature.title}>
                    <div
                      className="feature-item__icon"
                      style={{ background: "rgba(26,108,246,.15)", color: ACCENT }}
                    >
                      ✓
                    </div>
                    <div>
                      <strong style={{ color: "var(--text-primary)" }}>{feature.title}</strong> —{" "}
                      {feature.desc}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.1} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {HIGHLIGHT_CARDS.map((card) => (
                <div
                  className="card"
                  key={card.title}
                  style={
                    card.featured
                      ? {
                          "--accent": ACCENT,
                          padding: "28px",
                          textAlign: "center",
                          background:
                            "linear-gradient(135deg,rgba(26,108,246,.12),rgba(0,145,255,.04))",
                          borderColor: "rgba(26,108,246,.3)",
                        }
                      : {
                          "--accent": ACCENT,
                          padding: "28px",
                          textAlign: "center",
                        }
                  }
                >
                  <div
                    className="card__icon"
                    style={{
                      margin: "0 auto 12px",
                      background: "rgba(26,108,246,.12)",
                      color: ACCENT,
                    }}
                  >
                    <card.Icon />
                  </div>
                  <h3
                    style={{
                      fontFamily: "var(--font-display)",
                      fontWeight: 700,
                      marginBottom: "8px",
                      color: "var(--text-primary)",
                    }}
                  >
                    {card.title}
                  </h3>
                  <p style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                    {card.desc}
                  </p>
                </div>
              ))}
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ FAQ ═══════════════ */}
      <section className="section section--alt">
        <div className="container" style={{ maxWidth: "760px" }}>
          <Reveal className="text-center" style={{ marginBottom: "40px" }}>
            <div className="tag" style={{ color: ACCENT, background: "rgba(26,108,246,.1)", borderColor: "rgba(26,108,246,.25)" }}>
              FAQ sepolHOSTING
            </div>
            <h2 className="section-title">
              Dúvidas sobre <span style={{ color: ACCENT }}>hospedagem</span>
            </h2>
          </Reveal>

          {FAQS.map((faq, index) => (
            <Reveal
              className={`faq-item${openFaq === index ? " open" : ""}`}
              delay={index * 0.05}
              key={faq.question}
            >
              <button
                className="faq-btn"
                onClick={() => toggleFaq(index)}
                aria-expanded={openFaq === index}
              >
                {faq.question}
                <span className="faq-btn__icon">+</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">
              Pronto para ter um
              <br />
              site e e-mail profissional?
            </h2>
            <p className="cta-banner__sub">
              Fale com a sepolTECH e tenha hospedagem gerenciada com suporte
              de verdade.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Contratar sepolHOSTING →
              </Link>
              <Link to="/produtos/produtos" className="btn btn-outline">
                Ver outros produtos
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
